/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
	// Add custom code below this line
	// ^^ Keep your scripts inside this IIFE function call to
	// avoid leaking your variables into the global scope.
})();
const Flickity = themeVendor.Flickity
const registered = window.Shopify.theme.sections.registered;
const instances = window.Shopify.theme.sections.instances;

function validateComponentsArray(value) {
  if ((typeof value !== 'undefined' && typeof value !== 'object') || value === null) {
    throw new TypeError('Theme Sections: The components object provided is not a valid');
  }

  return value;
}

class Registration {
  constructor(type = null, components = []) {
    this.type = type;
    this.components = validateComponentsArray(components);
    this.callStack = {
      onLoad: [],
      onUnload: [],
      onSelect: [],
      onDeselect: [],
      onBlockSelect: [],
      onBlockDeselect: [],
      onReorder: [],
    };
    components.forEach((comp) => {
      for (const [key, value] of Object.entries(comp)) {
        const arr = this.callStack[key];
        if (Array.isArray(arr) && typeof value === 'function') {
          arr.push(value);
        } else {
          console.warn(`Unregisted function: '${key}' in component: '${this.type}'`);
          console.warn(value);
        }
      }
    });
  }

  getStack() {
    return this.callStack;
  }
}

function register(type, components) {
	if (typeof type !== 'string') {
		throw new TypeError('Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered');
	}

	if (typeof registered[type] !== 'undefined') {
		throw new Error('Theme Sections: A section of type "' + type + '" has already been registered. You cannot register the same section type twice');
	}

	if (!Array.isArray(components)) {
		components = [components];
	}

	const section = new Registration(type, components);
	registered[type] = section;

	return registered;
}

const selectors$t = {
	slider: '[data-slider]',
	sliderItem: '[data-slider-item]',
	sliderItemImage: '[data-media-container]',
	links: 'a, button',
	flickityButton: '.flickity-button',
};

const classes$l = {
	carouselInactive: 'carousel--inactive',
	carouselResize: 'carousel--resize',
};

const attributes$i = {
	tabIndex: 'tabindex',
};

const sections$m = {};

class ColumnsWithImage {
	constructor(section) {
		this.container = section.container;
		this.slider = this.container.querySelector(selectors$t.slider);
		this.flkty = null;
		this.gutter = 0;
		this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
		this.listen();
	}

	initSlider() {
		this.slider.classList.remove(classes$l.carouselInactive);

		this.flkty = new Flickity(this.slider, {
			pageDots: false,
			cellAlign: 'left',
			groupCells: true,
			contain: true,
			prevNextButtons: true,
			on: {
				ready: () => {
					this.setSliderArrowsPosition(this.slider);
					setTimeout(() => {
						this.changeTabIndex();
						this.flkty.resize();
					}, 0);
				},
				change: () => {
					this.changeTabIndex();
				},
			},
		});

		Flickity.prototype._createResizeClass = function () {
			this.element.classList.add(classes$l.carouselResize);
		};

		Flickity.createMethods.push('_createResizeClass');

		const resize = Flickity.prototype.resize;
		Flickity.prototype.resize = function () {
			this.element.classList.remove(classes$l.carouselResize);
			resize.call(this);
			this.element.classList.add(classes$l.carouselResize);
		};
	}

	destroySlider() {
		this.slider.classList.add(classes$l.carouselInactive);

		if (this.flkty !== null) {
			this.flkty.destroy();
			this.flkty = null;
		}
	}

	checkSlidesSize() {
		const sliderItemStyle =
			this.container.querySelector(selectors$t.sliderItem).currentStyle || window.getComputedStyle(this.container.querySelector(selectors$t.sliderItem));
		this.gutter = parseInt(sliderItemStyle.marginRight);
		const containerWidth = this.slider.offsetWidth;
		const itemsWidth = this.getItemsWidth();
		const itemsOverflowViewport = containerWidth < itemsWidth;

		if (window.innerWidth >= theme.sizes.small && itemsOverflowViewport) {
			this.initSlider();
		} else {
			this.initSlider();
			// this.destroySlider();
		}
	}

	changeTabIndex() {
		const selectedElementsIndex = this.flkty.selectedIndex;

		this.flkty.slides.forEach((slide, index) => {
			slide.cells.forEach((cell) => {
				cell.element.querySelectorAll(selectors$t.links).forEach((link) => {
					link.setAttribute(attributes$i.tabIndex, selectedElementsIndex === index ? '0' : '-1');
				});
			});
		});
	}

	getItemsWidth() {
		let itemsWidth = 0;
		const slides = this.slider.querySelectorAll(selectors$t.sliderItem);
		if (slides.length) {
			slides.forEach((item) => {
				itemsWidth += item.offsetWidth + this.gutter;
			});
		}

		return itemsWidth;
	}

	listen() {
		if (this.slider) {
			this.checkSlidesSize();
			document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
		}
	}

	setSliderArrowsPosition(slider) {
		const arrows = slider.querySelectorAll(selectors$t.flickityButton);
		const image = slider.querySelector(selectors$t.sliderItemImage);

		if (arrows.length && image) {
			arrows.forEach((arrow) => {
				arrow.style.top = `${image.offsetHeight / 2}px`;
			});
		}
	}

	onBlockSelect(evt) {
		if (this.flkty !== null) {
			const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
			const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
			const groupIndex = Math.floor(index / slidesPerPage);

			this.flkty.select(groupIndex);
		} else {
			const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
			const sliderPadding = parseInt(sliderStyle.paddingLeft);
			const blockPositionLeft = evt.target.offsetLeft - sliderPadding;

			// Native scroll to item
			this.slider.scrollTo({
				top: 0,
				left: blockPositionLeft,
				behavior: 'smooth',
			});
		}
	}

	onUnload() {
		document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
	}
}

const ColumnsWithImageSection = {
	onLoad() {
		sections$m[this.id] = new ColumnsWithImage(this);
	},
	onUnload(e) {
		sections$m[this.id].onUnload(e);
	},
	onBlockSelect(e) {
		sections$m[this.id].onBlockSelect(e);
	},
};

register('lcl-columns-with-image', [ColumnsWithImageSection]);
